import React from 'react';

import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';
import AboutPage, { IAboutPageProps } from '../../components/AboutPage';

const AboutHUHOOConfig: IAboutPageProps = {
    title: 'About HUHOO',
    header: 'HUHOO',
    paragraph: [
        'Computer operating programs, recorded; Downloadable computer game software; Downloadable computer search engine software;',
        'Downloadable computer software for use as a spreadsheet; Downloadable computer software to maintain and operate computer system;',
        'Downloadable electronic publications in the nature of magazines, books and journals in the field of financial services;',
        `Downloadable image file containing artwork, text, audio, video, games and Internet Web links relating to sporting and cultural activities;
        Portable media players; Video disks and video tapes with recorded animated cartoons;`,
        'Downloadable mobile applications for use in the field of stock and futures brokerage.'
    ],
    noMarginTop: true
};

const AboutHUHOO: React.FC = () => {
    return <AboutPage {...AboutHUHOOConfig} />;
};

export default withLazyLoad(withPid('brand')(AboutHUHOO));
